import {Injectable} from '@angular/core';
import {ConfigurationService} from '../core/services/configuration.service';
import {BaseService} from "~/app/core/services/base.service";
import { LoadingIndicatorHelper } from '../core/services/loading-indicator-helper';
import { lastValueFrom } from 'rxjs';
@Injectable({
  providedIn: 'root'
})

export class ErrorApiService {

  testHTTP500 = this._configuration.RESTURL + `/testhttp/500`;
  testHTTP400 = this._configuration.RESTURL + `/testhttp/400`;
  testHTTP401 = this._configuration.RESTURL + `/testhttp/401`;
  testHTTP403 = this._configuration.RESTURL + `/testhttp/403`;
  testHTTP404 = this._configuration.RESTURL + `/testhttp/404`;
  testHTTPSPLUNK = this._configuration.RESTURL + `/testhttp/splunk`;

  constructor(private _configuration: ConfigurationService,
              private baseService: BaseService,
              public loadingIndicator: LoadingIndicatorHelper) {
  }

  test500() {
    return lastValueFrom(this.baseService.getHttp(
      'test500',
      'error-api-service',
      this.testHTTP500))
      .then(response => response);
  }

  test400() {
    return lastValueFrom(this.baseService.getHttp(
      'test400',
      'error-api-service',
      this.testHTTP400))
      .then(response => response);
  }

  test401() {
    return lastValueFrom(this.baseService.getHttp(
      'test401',
      'error-api-service',
      this.testHTTP401))
      .then(response => response)
      .finally(() => this.loadingIndicator.hide());
  }

  test403() {
    return lastValueFrom(this.baseService.getHttp(
      'test403',
      'error-api-service',
      this.testHTTP403))
      .then(response => response)
      .finally(() => this.loadingIndicator.hide());
  }

  test404() {
    return lastValueFrom(this.baseService.getHttp(
      'test404',
      'error-api-service',
      this.testHTTP404))
      .then(response => response)
      .finally(() => this.loadingIndicator.hide());
  }

  testSplunk() {
    return lastValueFrom(this.baseService.getHttp(
      'testSplunk',
      'error-api-service',
      this.testHTTPSPLUNK))
      .then(response => response);
  }
}
